import { render, staticRenderFns } from "./plmIframe.vue?vue&type=template&id=d1fcd8a2&scoped=true"
import script from "./plmIframe.vue?vue&type=script&lang=js"
export * from "./plmIframe.vue?vue&type=script&lang=js"
import style0 from "./plmIframe.vue?vue&type=style&index=0&id=d1fcd8a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fcd8a2",
  null
  
)

export default component.exports